import {
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { filter, get } from 'lodash';
import {
  Address,
  AddVehicleToSelections,
  ArbitrationCase,
  AuctionItemBuyer,
  AuctionItemSell,
  BookProviderService,
  BookValueSpreadProviderName,
  BuyingDealer,
  ConfigurationState,
  DateUtilsService,
  EditPostingService,
  InventoryItemDetail,
  InventoryService,
  LaunchDarklyService,
  RemoveVehicleFromSelections,
  SearchFilterQueries, SearchFiltersState,
  SellerCommentService,
  SellerRemitDto,
  SellErrors, SellSearchState,
  SellState,
  SellToggleState,
  SettlementBatchService,
  StatusFilter,
  ToggleStateService,
  UpdateReturnToInventory,
  UpdateSellerComment,
  UpdateShouldMaintainPreviousSearchInState,
  UserProfile,
  VehicleProcessingState
} from 'remarketing-angular-library';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { take, takeUntil, tap } from 'rxjs/operators';
import { ActionStatus } from '../../enums';
import {
  EditCommentComponent,
  ErrorModalComponent,
  ModalPortalDirective,
  SaveCommentModalComponent
} from '../../../../../shared/ui';
import { FeeToolTipService } from '../../../../../shared/services/feetooltip/feetooltip.service';
import { getLocalDeliveryString } from 'src/app/shared/utils/util';
import { Router, RouterLink } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import {
  AnalyticsService,
  CurrencyFormatService,
  FormatPhoneNumberPipe, NameTruncatePipe,
  SaComponent, TelephoneLinkPipe,
  UtilityService
} from 'smartauction-frontend-micro-library';
import { Fee } from 'remarketing-angular-library/interfaces/buy-fee';
import { SellerOfferStatus } from 'remarketing-angular-library/enums/enums';
import { FeeTooltipFormatterService } from '../../../../../../src/app/shared/fee-tooltip-formatter/fee-tooltip-formatter.service';
import { EditPostingUtilsService } from 'src/sell/lib/posting/services/edit-posting-utils.service';
import { AuctionSummaryConfigurationService } from 'src/auction-summary/services/auction-summary-configuration/auction-summary-configuration.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import { DynamicBannerAlert, DynamicBannerAlertType } from 'src/shared/models/dynamic-banner-alert.model';
import {
  AuctionSummaryResultItemBannerComponent
} from '../../../../../shared/arbitration/components/auction-summary-result-item-banner/auction-summary-result-item-banner.component';
import {
  DatalistItemComponent,
  TooltipComponent,
  TrackDirective, VehicleDisclosuresIndicatorComponent
} from 'remarketing-ui-components-lib';
import {
  ImagesCountComponent
} from '../../../sell-shared/components/images-count/images-count.component';
import { NgxPrintModule } from 'ngx-print';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import {
  StateIndicatorComponent
} from '../../../../../shared/components/state-indicator/state-indicator.component';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { PurchaseHistoryComponent } from '../purchase-history/purchase-history.component';
import { RemovalHistoryComponent } from '../removal-history/removal-history.component';
import { SharedlistsService } from '../../../../../shared/services/sharedlists/sharedlists.service';
import { VehiclesService } from 'src/vehicles/services/vehicle-detail/vehicles.service';
@Component({
    selector: 'lib-vehicle-card',
    templateUrl: './vehicle-card.component.html',
    styleUrls: ['./vehicle-card.component.scss'],
    imports: [
        ErrorModalComponent,
        TranslocoDirective,
        AuctionSummaryResultItemBannerComponent,
        TrackDirective,
        RouterLink,
        ImagesCountComponent,
        NgxPrintModule,
        CollapseModule,
        StateIndicatorComponent,
        TooltipComponent,
        PurchaseHistoryComponent,
        RemovalHistoryComponent,
        CommonModule,
        FormatPhoneNumberPipe,
        TelephoneLinkPipe,
        NameTruncatePipe,
        EditCommentComponent,
        DatalistItemComponent,
        VehicleDisclosuresIndicatorComponent,
        ModalPortalDirective
    ]
})
export class VehicleCardComponent extends SaComponent implements OnInit {
  @Input() isVehicleSelected = false;
  @Input() auctionItemSell: AuctionItemSell;
  @Input() auctionItemBuyer: AuctionItemBuyer;
  @Input() index: number;
  @Input() userProfile: UserProfile;
  @Input() searchStatusFilter: StatusFilter;
  @Input() isMobileLayout: boolean;
  @Input() tenantName: string;
  @Input() isServiceFeeVisible: boolean;
  @Input() isDesktop: boolean;
  @Input() tenantUuid: string;
  @Input() bsoDealer: BuyingDealer;
  @Input() currentPage: number;
  @Input() offerLists;
  @Input() singleListSelected: boolean;
  @Input() sellerCommentsEnabled: boolean;
  @Input() bsoSelected: boolean;
  @Input() bsoMode: boolean;
  @Input() partOfBso: boolean;
  @Input() vehicleSelectionsEnabled: boolean;
  @Input() isFilterByInServiceVehicles = false;
  @Input() isIsvFileProcessing = false;

  @ViewChild('expandFocusTarget') expandFocusTarget: ElementRef<HTMLSpanElement>;
  @ViewChild(ModalPortalDirective, { static: true }) modalHost: ModalPortalDirective;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild('print') print!: ElementRef;

  @Select(SearchFilterQueries.selectedStatusFilter) readonly selectedStatusFilter$: Observable<StatusFilter>;
  @Select(VehicleProcessingState.processingVehicles) readonly processingVehicles$: Observable<any>;
  @Select(VehicleProcessingState.arrivedVehicles) readonly arrivedVehicles$: Observable<any>;

  private isCollapsed$$ = new BehaviorSubject(true);
  isCollapsed: boolean;

  groundedSubject = new BehaviorSubject<boolean>(false); // To manage the grounded state.
  groundedValue = this.groundedSubject.asObservable(); // To update and manage the view.

  commentsModalInstance: SaveCommentModalComponent;
  editingComment = false;
  imgUrlLarge: string;
  vdpCommentName = 'VDP Comment';
  filterByStatusSelected = StatusFilter.ACTIVE_VEHICLES;
  id = this.utilityService.generateId();
  spreadToBook: number;
  openArbitrationRequest = 'Open Arbitration Request';
  linkEvent = 'link';

  showAuctionStartTime = false;
  showAuctionEndTime = false;
  showAuctionExtendTime = false;
  showAuctionStartTimePending = false;

  bookValues: Array<any> = [];
  bannerAlerts = [];

  showSoldHistory = false;
  showRemovedHistory;
  showViewOffers: boolean;
  isOpenArbitration = false;
  claimNumber = 0;

  textBiddingInProgress: string;
  textBiddingEnded: string;
  singleFeeLabel: string;
  singleFeeAmount: number;
  tooltipContent: any;
  holdReasonList = ['N/A'];
  within60DayPeriod: boolean;
  editCutoffErrorMessage: string;

  offerListTooltipTitle = '';
  offerListTooltipBody = '';

  sellerRemitDto: SellerRemitDto = {} as SellerRemitDto;

  vehicleCardTranslations = {
    feesTooltipAriaLabel: '',
    saleFeesTooltipAriaLabel: '',
    distanceUnit: '',
    textTotalPrice: '',
    buyerFeesLabel: '',
    sellerFeesLabel: '',
    labelArbitration: '',
    textOpenRequest: '',
    labelArbitrationClosed: '',
    textCase: '',
    textCaseOpened: '',
    textInspectionSeriesLabel: '',
    partOf: '',
    sharedList: '',
    customOffer: '',
    currentListType: '',
    sharedListTooltipTitle: '',
    customOfferTooltipTitle: ''
  };

  listViewTableTranslations = {
    textVehicle: '',
    textOffers: '',
    textQuestions: '',
    textStatus: '',
    textHighestOffer: '',
    textBuyNow: '',
    textOpeningPrice: '',
    textSaleFee: '',
    textSalePrice: '',
    textTotalPrice: '',
    textStockUnitNumber: '',
    textAccept: '',
    textCounter: '',
    textDecline: '',
    textWithdraw: '',
    textRevive: '',
    textViewHistory: '',
    textEdit: '',
    textClose: '',
    textRepost: '',
    textViewPostingHistory: '',
    textEditListingGround: '',
    textUnreserve: '',
    textReserve: '',
    textChangeReservedDealership: '',
    textInspectionSeriesLabel: '',
    textVin: ''
  };

  sellerActionMapCounter = new Map<string, number>([
    ['ACCEPT', 0],
    ['DECLINE', 0],
    ['WITHDRAW', 0],
    ['COUNTER', 0],
    ['REVIVE', 0]
  ]);

  showProcessingBanner = false;
  showArrivedBanner = false;
  localTimeZoneNameExtended: string;
  disclosureToolTipRed: any;
  conditionIndicatorTranslations: {
    yellowTitle: '';
    yellowIconLetter: '';
  };
  formattedSpreadToBookLabels: { bookProviderName: string; bookProviderValue: string; } = {
    bookProviderName: '',
    bookProviderValue: ''
  };

  get manageInventoryMaxSelections(): number {
    return this.launchDarklyService.getFeatureFlag('sell-manageInventoryMaxSelections', -1);
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    protected store: Store,
    readonly toggleState: ToggleStateService,
    private readonly cfr: ComponentFactoryResolver,
    private readonly sellerCommentService: SellerCommentService,
    private readonly bookProviderService: BookProviderService,
    protected readonly _analyticsService: AnalyticsService,
    private readonly tooltipService: FeeToolTipService,
    protected readonly launchDarklyService: LaunchDarklyService,
    private readonly editPostingUtilsService: EditPostingUtilsService,
    private readonly editPostingService: EditPostingService,
    private readonly router: Router,
    private readonly inventoryService: InventoryService,
    private readonly translocoService: TranslocoService,
    private readonly utilityService: UtilityService,
    private readonly dateUtilService: DateUtilsService,
    private readonly settlementBatchService: SettlementBatchService,
    private readonly feeTooltipFormatterService: FeeTooltipFormatterService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly auctionSummaryConfigurationService: AuctionSummaryConfigurationService,
    private readonly sharedListsService: SharedlistsService,
    protected bsModalService: BsModalService,
    private readonly vehicleService: VehiclesService
  ) {
    super();
    this.bookValues = this.bookProviderService.bookValues;
  }

  getShareListVehicles() {
    this.offerListTooltipBody = this.sharedListsService.offerListTooltipBody(this.offerLists);
  }

  get isSellerArbitrationEnabled(): boolean {
    return this.auctionSummaryConfigurationService.isSellerArbitrationEnabled;
  }

  get offerListsTooltip() {
    return this.sharedListsService.offerListsTooltip(this.offerListTooltipTitle, this.offerListTooltipBody);
  }

  get isOfferListsTooltipEmpty() {
    return this.sharedListsService.isOfferListsTooltipBodyEmpty(this.offerListTooltipBody);
  }

  get title() {
    return `${this.detail('modelYear')} ${this.detail('make')} ${this.detail('model')} ${this.detail('trim')} ${
      this.driveTrain
    } `;
  }

  detail(key: keyof InventoryItemDetail): string {
    return get(this.itemDetails, key, '');
  }

  get itemDetails(): any | {} {
    return get(this.auctionItemSell, 'itemDetail', {});
  }

  get driveTrain() {
    return get(this.auctionItemSell, 'itemDetail.powerTrain.driveTrainAbbrev', '');
  }

  getAuctionItemSellProp(path: string, otherwise: any = 'N/A'): string {
    return get(this.auctionItemSell, path, otherwise);
  }

  get openOfferCount() {
    return this.auctionItemSell ? this.auctionItemSell.offerCount : 0;
  }

  get highestOffer() {
    if (this.auctionItemSell && this.auctionItemSell.highestOffer) {
      return this.auctionItemSell.highestOffer;
    }
    return undefined;
  }

  get openQuestionCount() {
    return this.auctionItemSell ? this.auctionItemSell.openQuestionCount : 0;
  }

  get bookProvider(): string {
    return `${this.formattedSpreadToBookLabels.bookProviderName} ${this.formattedSpreadToBookLabels.bookProviderValue}`;
  }

  get bidStatus() {
    if (
      this.auctionItemSell &&
      !this.auctionItemSell.openingPrice &&
      this.auctionItemSell.auctionItemStatus === 'ACTIVE'
    ) {
      if (this.auctionItemSell.auctionWindow) {
        return this.textBiddingInProgress;
      } else {
        return this.textBiddingEnded;
      }
    } else {
      return undefined;
    }
  }

  get showDeliveryField(): boolean {
    return this.launchDarklyService.getFeatureFlag('inventory-deliveryEnabled', true);
  }

  private readonly statusMap = {
    [ActionStatus.PENDING_SELLER_ACTION]: { text: 'Pending Seller Action', variant: 'danger' },
    [ActionStatus.PENDING_BUYER_ACTION]: { text: 'Pending Buyer Action', variant: 'dark' },
    [ActionStatus.NO_ACTION]: { text: 'No Action', variant: 'success' },
    [ActionStatus.HOLD]: { text: 'Hold', variant: 'grey' },
    [ActionStatus.REMOVED]: { text: 'Removed', variant: 'removed' },
    [ActionStatus.EXPIRED]: { text: 'Removed', variant: 'removed' }
  };

  get status() {
    // Check auction item status for the case of Hold vehicles, which have a grey indicator
    let status = this.getAuctionItemSellProp('actionStatus', this.getAuctionItemSellProp('auctionItemStatus', ''));
    if (this.filterByStatusSelected === StatusFilter.REMOVED_VEHICLES) {
      status = this.getAuctionItemSellProp('auctionItemStatus', '');
    } else if (
      this.filterByStatusSelected === StatusFilter.ALL_VEHICLES &&
      (this.auctionItemSell.auctionItemStatus === StatusFilter.REMOVED_VEHICLES ||
        this.auctionItemSell.auctionItemStatus === StatusFilter.EXPIRED_VEHICLES)
    ) {
      status = this.getAuctionItemSellProp('auctionItemStatus', '');
    }
    return this.statusMap[status] || { text: '', variant: '' };
  }

  get statusChangedDate() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItemSell.statusChangedDate, true);
  }

  get datePosted() {
    return this.dateUtilService.localizeDateAndTime(this.getAuctionItemSellProp('postedDate'), true);
  }

  get auctionStartTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItemSell.auctionStartTime, true);
  }

  get auctionEndTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItemSell.auctionEndTime, true);
  }

  get auctionExtendedTime() {
    const extendedTime = this.dateUtilService.localizeDateAndTime(this.auctionItemSell.auctionExtendEndTime, true);
    if (extendedTime !== '') {
      return extendedTime + this.localTimeZoneNameExtended;
    } else {
      return extendedTime;
    }
  }

  get tenantBadgeValue(): string {
    const value = this.auctionItemSell.auctionTenant ? this.auctionItemSell.auctionTenant : 'N/A';
    return value;
  }

  get saleDateTime() {
    return this.dateUtilService.localizeDateAndTime(this.auctionItemSell.saleDate, true);
  }

  get isProceedsDisplay(): boolean {
    return (
      this.isReleaseProceedsEnabled &&
      (this.auctionItemSell.holdProceedsTypeCode == 'R' || this.auctionItemSell.holdProceedsTypeCode == 'H')
    );
  }

  get releasedDate(): string {
    if (this.auctionItemSell.proceedsReleasedDate == undefined || this.auctionItemSell.proceedsReleasedDate == null) {
      return '';
    }
    return this.dateUtilService.localizeDateAndTime(this.auctionItemSell.proceedsReleasedDate, true);
  }

  get settlementDateValue(): string {
    const settlementDate = this.dateUtilService.localizeDate(this.auctionItemSell.settlementDate);
    if (settlementDate === '') {
      return 'N/A';
    } else {
      return settlementDate;
    }
  }

  get localDeliveryValue(): string {
    return getLocalDeliveryString(this.auctionItemSell.localDelivery);
  }

  get getSellerName() {
    const sellerName =
      this.auctionItemSell.seller && this.auctionItemSell.seller.name ? this.auctionItemSell.seller.name : 'N/A';
    return sellerName;
  }

  get platformTenantName() {
    return get(this.store.selectSnapshot(ConfigurationState.configuration), 'tenantFullName', '');
  }

  get platformAddress() {
    return get(this.store.selectSnapshot(ConfigurationState.configuration), 'platform.address', '');
  }

  get platformProvider() {
    const name = get(this.store.selectSnapshot(ConfigurationState.configuration), 'platform.name', '');
    const quebecReg = get(
      this.store.selectSnapshot(ConfigurationState.configuration),
      'platform.quebecRegistrationNumber',
      ''
    );
    const federalTaxId = get(this.store.selectSnapshot(ConfigurationState.configuration), 'platform.federalTaxId', '');
    return `${name} (Business #: ${federalTaxId}; Quebec Registration #: ${quebecReg})`;
  }

  get getRemovalReason() {
    const removalReason =
      this.auctionItemSell.itemStatusReasons[0] && this.auctionItemSell.itemStatusReasons[0].reason
        ? this.auctionItemSell.itemStatusReasons[0].reason
        : '';
    const removalBy =
      this.auctionItemSell.itemStatusReasons[0] && this.auctionItemSell.itemStatusReasons[0].updatedBy
        ? `(${this.auctionItemSell.itemStatusReasons[0].updatedBy})`
        : '';
    return `${removalReason} ${removalBy}`;
  }

  get arbitrationClaimRoute(): string {
    return this.isOpenArbitration
      ? `/arbitration/${this.auctionItemSell.auctionItemUuid}/${this.claimNumber}`
      : `/arbitration/${this.auctionItemSell.auctionItemUuid}/new`;
  }

  setArbitrationClaim() {
    if (this.auctionItemSell.arbitrationCases) {
      this.auctionItemSell.arbitrationCases.forEach(arbitrationCase => {
        if (arbitrationCase.status === 'OPEN') {
          this.isOpenArbitration = true;
          this.claimNumber = arbitrationCase.claimNumber;
          this.bannerAlerts.push(
            new DynamicBannerAlert({
              type: DynamicBannerAlertType.ARBITRATION_CASE,
              alertContent: {
                ...arbitrationCase,
                link: this.arbitrationClaimRoute
              }
            } as DynamicBannerAlert)
          );
        }
      });
    }
  }

  // constructs the auctionItem reasons array
  getHoldReason() {
    if (
      this.auctionItemSell &&
      this.auctionItemSell.auctionItemStatus === this.statusFilter.HOLD_VEHICLES &&
      this.auctionItemSell.itemStatusReasons
    ) {
      // filtering reason only if statusCleared false
      const nonClearedStatuses = [...this.auctionItemSell.itemStatusReasons].filter(r => !r.statusCleared);
      // Lower legacyReasonId means it was created earlier
      nonClearedStatuses.sort((r1, r2) => (r1.legacyReasonId < r2.legacyReasonId ? -1 : 1));
      // mapping only reasons array
      const reasonList = nonClearedStatuses.map(item => {
        return item.reason;
      });
      this.holdReasonList = reasonList.length ? reasonList : this.holdReasonList;
    }
  }

  /**
   * AuctionItem Title Address Detail
   */
  titleAddress(key: keyof Address): string {
    return get(this.titleAddressValue, key, '');
  }

  get titleAddressValue(): any | {} {
    return get(this.auctionItemSell, 'titleAddress', {});
  }

  get titleAddressName() {
    const nameValue = this.titleAddress('name') ? this.titleAddress('name') : 'N/A';
    return nameValue;
  }

  get titleAddressDetail() {
    const address1 = this.titleAddress('addressLine1') ? this.titleAddress('addressLine1') : 'N/A';
    return address1;
  }

  get titleAddressDetail2() {
    const address2 = this.titleAddress('addressLine2') ? this.titleAddress('addressLine2') : '';
    return address2;
  }

  get titleAddressRegion() {
    const city = this.titleAddress('city') ? this.titleAddress('city') : 'N/A';
    const state = this.titleAddress('state') ? this.titleAddress('state') : 'N/A';
    const zip = this.titleAddress('zip') ? this.titleAddress('zip') : 'N/A';
    return `${city}, ${state} ${zip}`;
  }

  /**
   * AuctionItem buyer info detail
   */
  buyerDetails(key: keyof AuctionItemBuyer) {
    return get(this.buyerDetailsValue, key, '');
  }

  get buyerDetailsValue(): any | {} {
    return get(this.auctionItemSell, 'buyerDetails', {});
  }

  get buyerDetailsPhysicalAddress(): Address {
    return this.buyerDetails('physicalAddress');
  }

  get buyerContactDetails(): any {
    return get(this.auctionItemSell, 'buyerDetails.contactDetails.buyer', {});
  }

  get buyerDetailsName(): string {
    return this.buyerDetails('legalName') || 'N/A';
  }

  get buyerDetailsAddress(): string {
    const buyerAddressLine1 = this.buyerDetailsPhysicalAddress.addressLine1
      ? this.buyerDetailsPhysicalAddress.addressLine1
      : 'N/A';

    return buyerAddressLine1;
  }

  get buyerDetailsAddress2(): string {
    return this.buyerDetailsPhysicalAddress.addressLine2 ? this.buyerDetailsPhysicalAddress.addressLine2 : '';
  }

  get buyerDetailRegion(): string {
    const city = this.buyerDetailsPhysicalAddress.city ? this.buyerDetailsPhysicalAddress.city : 'N/A';
    const state = this.buyerDetailsPhysicalAddress.state ? this.buyerDetailsPhysicalAddress.state : 'N/A';
    const zip = this.buyerDetailsPhysicalAddress.zip ? this.buyerDetailsPhysicalAddress.zip : 'N/A';
    return `${city}, ${state} ${zip}`;
  }

  get buyerDetailPhone(): string | null {
    return this.buyerContactDetails.phone ? this.buyerContactDetails.phone : null;
  }

  get buyerDetailName(): string | null {
    return this.buyerContactDetails.name ? this.buyerContactDetails.name : 'N/A';
  }

  get buyerDetailAuctionAccessId(): string | null {
    return this.buyerContactDetails.auctionAccessId ? this.buyerContactDetails.auctionAccessId : null;
  }

  get buyerDetailEmail(): string | null {
    return this.buyerContactDetails.email ? this.buyerContactDetails.email : 'N/A';
  }

  get buyerDetailsPrimaryPhone(): string | null {
    return this.buyerDetails('primaryPhone') ? this.buyerDetails('primaryPhone') : null;
  }

  get isTenantBadgeEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-tenantBadgeEnabled', false);
  }

  get isRemovedActionsEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('menu-sell-removedVariation', 0) !== 0;
  }

  get isHoldActionsEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('menu-sell-holdVariation', 0) !== 0;
  }

  get isBuyerDetailsEmailEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('inventory-export-buyerDetailsEnabled', false);
  }

  get customerIdDetail(): any {
    return get(this.auctionItemSell, 'customerId', 'N/A');
  }

  get buyerFinanceSourceDetail(): any {
    return get(this.auctionItemSell, 'buyerFinanceSource', 'N/A');
  }

  get closedArbitrationCases(): ArbitrationCase[] {
    return filter(this.auctionItemSell.arbitrationCases, { status: 'CLOSED' });
  }

  get isVehicleGounded(): boolean {
    return (
      this.auctionItemSell.groundedDate !== null &&
      this.auctionItemSell.groundedDate !== undefined &&
      this.auctionItemSell.groundedDate.length > 0
    );
  }
  
  initializeBookProviderValueLabels() {
    this.formattedSpreadToBookLabels = this.vehicleService.formatBookProviderLabel(
      this.bookProviderService.defaultBookProviderName,
      this.bookProviderService.defaultBookProviderValue
    );
  }

  ngOnInit() {
    this.initializeBookProviderValueLabels();
    /* istanbul ignore next */
    this.imgUrlLarge = this.getAuctionItemSellProp('itemDetail.image', '');
    this.checkDrawer();
    this.determineAuctionTimeDisplay();
    this.groundedSubject.next(this.isVehicleGounded); // Combine value coming from auctionItemSell into one observable.
    const globalCollapse$ = this.toggleState.isCollapsed$.pipe(
      tap(isCollapsed => this.isCollapsed$$.next(isCollapsed))
    );
    const localCollapse$ = this.isCollapsed$$.asObservable().pipe(
      tap(isCollapsed => {
        this.isCollapsed = isCollapsed;
        this.changeDetectorRef.markForCheck();
      })
    );
    merge(globalCollapse$, localCollapse$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe();

    this.selectedStatusFilter$.pipe(takeUntil(this.destroyed$)).subscribe(statusFilter => {
      this.filterByStatusSelected = statusFilter;
    });

    this.processingVehicles$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.store
        .select(VehicleProcessingState.isVehicleInProcessing(this.auctionItemSell.auctionItemUuid))
        .pipe(takeUntil(this.destroyed$))
        .subscribe(x => {
          this.showProcessingBanner = x;
        });
    });
    this.arrivedVehicles$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.store
        .select(VehicleProcessingState.isVehicleInArrived(this.auctionItemSell.auctionItemUuid))
        .pipe(takeUntil(this.destroyed$))
        .subscribe(hasArrived => {
          this.showArrivedBanner = hasArrived;
          if (hasArrived && this.auctionItemSell.inTransit) {
            this.auctionItemSell = { ...this.auctionItemSell, inTransit: false };
          }
        });
    });
    this.getHoldReason();
    this.setArbitrationClaim();
    this.getTranslations();
    this.offerListTooltipTitle = !this.isFilterByInServiceVehicles ? this.vehicleCardTranslations.customOfferTooltipTitle : this.vehicleCardTranslations.sharedListTooltipTitle;
    this.getShareListVehicles();
  }

  getTranslations() {
    const keyParams = {
      shared: {},
      'sellModule.manageInventory': {},
      common: {},
      'offerList.general': {},
      'auctionSummary.auctionSummaryResultItem': {},
      UIComponents: {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (translation: any[]) => {
          this.vehicleCardTranslations.feesTooltipAriaLabel =
            translation[0].feeTooltipModal.textMoreInformationAriaLabelFeesSold;
          this.vehicleCardTranslations.saleFeesTooltipAriaLabel =
            translation[0].feeTooltipModal.textMoreInformationAriaLabelSaleFeesSold;
          this.vehicleCardTranslations.buyerFeesLabel = translation[0].feeTooltipModal.textBuyerFees;
          this.vehicleCardTranslations.sellerFeesLabel = translation[0].feeTooltipModal.textSellerFees;
          this.disclosureToolTipRed = translation[1].vehicleCard.disclosureToolTipR;
          this.editCutoffErrorMessage = translation[1].vehicleCard.editCutoffTimeError;
          this.textBiddingInProgress = translation[1].vehicleCard.textBiddingInProgress;
          this.textBiddingEnded = translation[1].vehicleCard.textBiddingEnded;
          this.localTimeZoneNameExtended = translation[2].localTimeZoneNameExtended;
          this.vehicleCardTranslations.distanceUnit = translation[2].distanceUnit;
          this.vehicleCardTranslations.textInspectionSeriesLabel = translation[1].vehicleCard.textInspectionSeries;
          this.vehicleCardTranslations.sharedListTooltipTitle = translation[3].offerListToolTipTitle;
          this.vehicleCardTranslations.customOfferTooltipTitle = translation[3].customOfferToolTipTitle;
          this.vehicleCardTranslations.partOf = translation[3].partOf;
          this.vehicleCardTranslations.sharedList = translation[3].sharedList;
          this.vehicleCardTranslations.customOffer = translation[3].customOffer;
          this.vehicleCardTranslations.currentListType = this.isInServiceVehiclesEnabled && !this.isFilterByInServiceVehicles ? this.vehicleCardTranslations.customOffer : this.vehicleCardTranslations.sharedList;
          this.listViewTableTranslations.textHighestOffer = translation[1].listView.textHighestOffer;
          this.listViewTableTranslations.textOpeningPrice = translation[1].listView.textOpeningPrice;
          this.listViewTableTranslations.textSalePrice = translation[1].listView.textSalePrice;
          this.listViewTableTranslations.textSaleFee = translation[1].listView.textSaleFee;
          this.listViewTableTranslations.textStatus = translation[1].listView.textStatus;
          this.listViewTableTranslations.textBuyNow = translation[1].listView.textBuyNow;
          this.listViewTableTranslations.textStockUnitNumber = translation[1].listView.textStockUnitNumber;
          this.listViewTableTranslations.textClose = translation[1].listView.textClose;
          this.listViewTableTranslations.textAccept = translation[1].listView.textAccept;
          this.listViewTableTranslations.textCounter = translation[1].listView.textCounter;
          this.listViewTableTranslations.textDecline = translation[1].listView.textDecline;
          this.listViewTableTranslations.textWithdraw = translation[1].listView.textWithdraw;
          this.listViewTableTranslations.textRevive = translation[1].listView.textRevive;
          this.listViewTableTranslations.textOffers = translation[1].listView.textOffers;
          this.listViewTableTranslations.textQuestions = translation[1].listView.textQuestions;
          this.listViewTableTranslations.textViewHistory = translation[1].listView.textViewHistory;
          this.listViewTableTranslations.textEdit = translation[1].listView.textEdit;
          this.listViewTableTranslations.textRepost = translation[1].listView.textRepost;
          this.listViewTableTranslations.textViewPostingHistory = translation[1].listView.textViewPostingHistory;
          this.listViewTableTranslations.textEditListingGround = translation[1].listView.textEditListingGround;
          this.listViewTableTranslations.textUnreserve = translation[1].listView.textUnreserve;
          this.listViewTableTranslations.textReserve = translation[1].listView.textReserve;
          this.listViewTableTranslations.textChangeReservedDealership = translation[1].listView.textChangeReservedDealership;
          this.listViewTableTranslations.textInspectionSeriesLabel = translation[1].listView.textInspectionSeriesLabel;
          this.listViewTableTranslations.textVin = translation[1].listView.textVinLabel;
          this.vehicleCardTranslations.labelArbitration = translation[4].labelArbitration;
          this.vehicleCardTranslations.textOpenRequest = translation[4].textOpenRequest;
          this.vehicleCardTranslations.labelArbitrationClosed = translation[4].labelArbitrationClosed;
          this.vehicleCardTranslations.textCase = translation[4].textCase;
          this.vehicleCardTranslations.textCaseOpened = translation[4].textCaseOpened;
          this.conditionIndicatorTranslations = translation[5].conditionIndicatorTranslations;
        },
        error => {
          console.log(error);
        }
      );
    this.showAvailableMultiActions();
  }

  updateBackToInventory() {
    this.store.dispatch(new UpdateReturnToInventory(this.currentPage));
    this.store.dispatch(new UpdateShouldMaintainPreviousSearchInState(true));
  }

  checkDrawer() {
    const drawerUuid = this.store.selectSnapshot(SellState.DrawerStatus);
    if (drawerUuid === this.auctionItemSell.auctionItemUuid) {
      this.showRemovedHistory = true;
    }
  }

  determineAuctionTimeDisplay() {
    if (this.auctionItemSell) {
      !this.auctionItemSell.auctionWindow
        ? this.determineDisplayTimeOutsideOfAuction()
        : this.determineDisplayTimeForOngoingAuctions();
    }
  }

  private determineDisplayTimeForOngoingAuctions() {
    this.auctionItemSell.auctionWindow === 'INPROGRESS'
      ? (this.showAuctionEndTime = true)
      : this.auctionItemSell.auctionWindow === 'EXTENDED'
      ? (this.showAuctionExtendTime = true)
      : (this.showAuctionStartTime = true);
  }

  private determineDisplayTimeOutsideOfAuction() {
    if (this.dateUtilService.isLessThanCurrentDateAndTime(this.auctionItemSell.auctionEndTime)) {
      this.showAuctionStartTimePending = true;
    } else {
      this.showAuctionStartTime = true;
    }
  }

  getSpreadToBookValue() {
    if (this.spreadToBook) {
      return this.spreadToBook;
    }
    if (!this.userProfile || !this.userProfile.userPreferences) {
      return undefined;
    }
    const defaultBookProvider = this.userProfile.userPreferences.defaultBookProvider.providerName;
    const defaultProviderValue = this.userProfile.userPreferences.defaultBookProvider.providerValue;

    let bookProviders = [];

    if (defaultBookProvider === BookValueSpreadProviderName.MMR){
      bookProviders = this.auctionItemSell.bookValues.filter( bookValue => bookValue.providerName === BookValueSpreadProviderName.MANHEIM )
    }else{
      bookProviders = this.auctionItemSell.bookValues.filter( bookValue => bookValue.providerName === defaultBookProvider )
    }

    if (bookProviders.length > 0) {
      return this.getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue);
    }

    return undefined;
  }

  getCurrentValue(bookProviders, defaultBookProvider, defaultProviderValue) {
    const filteredProvider = bookProviders[0];
    let providerValue =
      defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.NADA.toLocaleLowerCase() ||
      defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.BLACK_BOOK.toLocaleLowerCase() ||
      defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.MMR.toLocaleLowerCase()
        ? `${defaultProviderValue}`.toLocaleLowerCase()
        : null;

    //using regex for case-insensitive replacement of 'Adjusted ' from provider value for manheim
    if (providerValue && defaultBookProvider.toLocaleLowerCase() === BookValueSpreadProviderName.MMR.toLocaleLowerCase()) {
      providerValue = providerValue.replace(/^adjusted\s+/i, '');
    }

    const filteredBookValues = filteredProvider.values.filter(
      value => value.providerValue.toLocaleLowerCase() === providerValue
    );

    if (filteredBookValues.length > 0) {
      this.spreadToBook = filteredBookValues[0].valueAmount;
      return this.spreadToBook;
    }
  }

  formatCurrency(currency, withCents?) {
    return this.currencyFormatService.formatCurrency(currency, withCents).replaceAll('-', '');
  }

  getBidStatusClasses() {
    let classList = '';
    if (!this.auctionItemSell.openingPrice) {
      if (this.showAuctionExtendTime) {
        classList = 'has-extended-bid-status';
      } else {
        classList = 'has-bid-status';
      }
    }
    if (this.openOfferCount > 0 || this.openQuestionCount > 0) {
      classList += ' has-action-badge';
    }
    return classList;
  }

  getStatusIndicatorClass() {
    switch (this.auctionItemSell.auctionItemStatus) {
      case StatusFilter.SOLD_VEHICLES:
      case StatusFilter.ACTIVE_VEHICLES:
        return 'three-row-status-indicator';
      case StatusFilter.REMOVED_VEHICLES:
        return 'two-row-status-indicator';
      default:
        return null;
    }
  }

  get partOfSharedListClassList() {
    return 'd-flex align-items-center ms-1 ' + (this.openOfferCount > 0 ? 'ms-md-2' : 'ms-md-0');
  }

  toggleCollapse() {
    this._analyticsService.track('clickEvent', {
      tagName: 'BUTTON',
      allytmln: this.isCollapsed ? 'Expand Vehicle Card' : 'Collapse Vehicle Card',
      linkName: this.isCollapsed ? 'Expand Vehicle Card' : 'Collapse Vehicle Card',
      href: 'javascript:void(0);'
    });

    this.isCollapsed$$.next(!this.isCollapsed$$.getValue());

    setTimeout(() => {
      if (!this.isCollapsed && this.expandFocusTarget) {
        this.expandFocusTarget.nativeElement.focus();
      }
    }, 1);
  }

  get showTenantServiceFee() {
    return this.isServiceFeeVisible && this.auctionItemSell.auctionItemTenantUuid === this.tenantUuid;
  }

  scrollToHistory(event: MouseEvent) {
    setTimeout(() => {
      const vehicleCardDiv = (event.target as HTMLElement).closest('.card').firstElementChild;
      vehicleCardDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 300);
  }

  displaySoldHistory(event: MouseEvent) {
    this.showSoldHistory = !this.showSoldHistory;

    if (event.target) {
      this.scrollToHistory(event);
    }
  }

  displayRemovedHistory(event: MouseEvent) {
    this.showRemovedHistory = !this.showRemovedHistory;

    if (event.target) {
      this.scrollToHistory(event);
    }
  }

  updateComment(updatedComment: string) {
    this.showCommentsModal();
    this.sellerCommentService
      .upsertSellerComment(updatedComment, this.auctionItemSell.auctionItemUuid)
      .pipe(take(1))
      .subscribe(
        res => {
          this.store.dispatch(new UpdateSellerComment(res.auctionItemUuid, res.sellerComment));
          this.commentsModalInstance.state = 'success';
          this.changeDetectorRef.markForCheck();
          this._analyticsService.track('customEvent', {
            name: this.vdpCommentName,
            attr: {
              formValues: {
                name: this.vdpCommentName,
                status: 'success',
                errors: null,
                type: '',
                step: '1',
                stepname: '',
                items: [
                  {
                    allow: 'yes',
                    error: null,
                    name: 'Comment',
                    track: 'no',
                    value: updatedComment
                  }
                ]
              }
            }
          });
        },
        err => {
          this.commentsModalInstance.state = 'error';
          this.changeDetectorRef.markForCheck();
          const error = get(err, 'error.errors[0]');
          const errorText = SellErrors.getErrorMessage(error.code);
          this.commentsModalInstance.errorText = errorText.message;
          this._analyticsService.track('customError', errorText.message, error.code, {
            formValues: {
              name: this.vdpCommentName,
              status: 'error',
              errors: error,
              type: '',
              step: '1',
              stepname: '',
              items: [
                {
                  allow: 'yes',
                  error: null,
                  name: 'Comment',
                  track: 'no',
                  value: updatedComment
                }
              ]
            }
          });
        }
      );
  }

  private showCommentsModal() {
    const factory = this.cfr.resolveComponentFactory(SaveCommentModalComponent);
    const viewContainerRef = this.modalHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(factory);
    this.commentsModalInstance = (componentRef.instance as unknown) as SaveCommentModalComponent;
    this.commentsModalInstance.tenantName = this.tenantName;
    setTimeout(() => {
      this.commentsModalInstance.show();
      this.changeDetectorRef.markForCheck();
    });
  }

  editComment(e) {
    e.preventDefault();
    this.editingComment = true;
  }

  cancelEditComment() {
    this.editingComment = false;
  }

  get feeDetailsTooltip() {
    this.tooltipContent = this.tooltipService.getFeeValues(this.auctionItemSell.buyFee.fees);
    return {
      title: this.vehicleCardTranslations.buyerFeesLabel,
      metaTitle: this.vehicleCardTranslations.feesTooltipAriaLabel,
      body: this.tooltipContent
    };
  }

  get sellFeeDetailsTooltip() {
    this.tooltipContent = this.tooltipService.getFeeValues(this.auctionItemSell.sellFee.fees);
    return {
      title: this.vehicleCardTranslations.sellerFeesLabel,
      metaTitle: this.vehicleCardTranslations.saleFeesTooltipAriaLabel,
      body: this.tooltipContent
    };
  }

  get buyFeesForPrint() {
    if (this.isTenantCanadian()) {
      return this.feeTooltipFormatterService.getFeeMap(
        this.tooltipService.translatedFees(this.removeTaxesFromFeesList(this.auctionItemSell.buyFee.fees))
      );
    } else {
      return this.feeTooltipFormatterService.getFeeMap(
        this.tooltipService.translatedFees(this.auctionItemSell.buyFee.fees)
      );
    }
  }

  get sellFeesForPrint() {
    return this.feeTooltipFormatterService.getFeeMap(
      this.tooltipService.translatedFees(this.auctionItemSell.sellFee.fees)
    );
  }

  getBuyFeeDetailsSizeForPrint(fees: Fee[]) {
    if (this.isTenantCanadian()) {
      return this.getFeeDetailsSize(this.removeTaxesFromFeesList(fees));
    } else {
      return this.getFeeDetailsSize(fees);
    }
  }

  getSellFeeDetailsSizeForPrint(fees: Fee[]) {
    return this.getFeeDetailsSize(fees);
  }

  removeTaxesFromFeesList(fees: Fee[]) {
    return fees.filter(fee => !fee.description.toUpperCase().includes('TAX'));
  }

  // function used for the keyvalue pipe to maintain the order of the fees. Changing default from return 0 to emtpy function as return 0 wouldn't work with Angular upgrade.
  returnUndefined() {
    return undefined;
  }

  getFeeDetailsSize(fees: Fee[]) {
    const feesKeyMap = this.feeTooltipFormatterService.getFeeMap(this.tooltipService.translatedFees(fees));
    const feeSize = Object.keys(feesKeyMap).length;
    if (fees && feeSize === 1) {
      for (const key in feesKeyMap) {
        const value = feesKeyMap[key];
        this.singleFeeLabel = key;
        this.singleFeeAmount = value;
      }
    }
    return fees && feeSize;
  }

  auctionItemSellWithRemitData() {
    if (this.isTenantCanadian() && this.auctionItemSell.auctionItemStatus === StatusFilter.SOLD_VEHICLES) {
      this.settlementBatchService
        .getSellerRemitDto(this.auctionItemSell.auctionItemUuid)
        .pipe(take(1))
        .subscribe(
          dto => {
            this.sellerRemitDto = dto;
          },
          error => {
            console.log(error);
          }
        );
    }
  }

  // Used to intercept the print function for ngx-print, as it fetches seller remit data before displaying the print screen
  public triggerPrint(): void {
    this.auctionItemSellWithRemitData();
    setTimeout(() => {
      this.print.nativeElement.click();
    }, 500);
  }

  get sellFeeTooltip() {
    return this.auctionItemSell.sellFee.fees && this.auctionItemSell.sellFee.fees.length > 1;
  }

  get buyFeesTotalAmount() {
    return this.auctionItemSell.buyFee.total;
  }

  get sellFeesTotalAmount() {
    return this.auctionItemSell.sellFee.total;
  }

  get statusFilter() {
    return StatusFilter;
  }

  get isReservedStatusFilter() {
    return this.isFilterByInServiceVehicles && this.filterByStatusSelected === 'RESERVED';
  }

  get isVehicleTypeFilterISV() {
    return this.isFilterByInServiceVehicles;
  }

  // Marks a given vehicle as selected
  toggleSelected() {
    this._analyticsService.trackEvent(
      'checkbox',
      'Selected ' + this.auctionItemSell.inventoryItemUuid + ' - ' + !this.isVehicleSelected
    );
    if (this.isVehicleSelected) {
      this.store.dispatch(new RemoveVehicleFromSelections(this.auctionItemSell));
    } else {
      this.store.dispatch(new AddVehicleToSelections(this.auctionItemSell));
    }
  }

  get showActionBarCheckbox() {
    if (this.searchStatusFilter === StatusFilter.SHARED_VEHICLES) {
      return (
        this.isOfferListSellerSelectAllEnabled &&
        this.singleListSelected &&
        this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES &&
        (this.isPendingBuyerAction || this.isPendingSellerAction)
      );
    }

    // only enable checkboxes for ISV. Disabled for Avis Direct
    if (this.inServiceVehiclesEnabled && !this.isFilterByInServiceVehicles) {
      this.vehicleSelectionsEnabled = false;
    }

    return (
      !this.bsoMode &&
      (this.vehicleSelectionsEnabled ||
        (this.isSellReportingFeatureEnabled &&
          this.auctionItemSell.auctionItemStatus === StatusFilter.SOLD_VEHICLES)) &&
      (this.auctionItemSell.auctionItemStatus === StatusFilter.HOLD_VEHICLES ||
        this.auctionItemSell.auctionItemStatus === StatusFilter.ACTIVE_VEHICLES ||
        this.auctionItemSell.auctionItemStatus === StatusFilter.RESERVED_VEHICLES ||
        this.auctionItemSell.auctionItemStatus === StatusFilter.SOLD_VEHICLES)
    );
  }

  get disableActionBarCheckbox() {
    if (
      !this.isVehicleSelected &&
      this.manageInventoryMaxSelections > -1 &&
      this.store.selectSnapshot(SellToggleState.selectedVehicles)?.length >= this.manageInventoryMaxSelections
    ) {
      return true;
    }

    if (this.searchStatusFilter === StatusFilter.SHARED_VEHICLES) {
      return this.isOfferListSellerSelectAllEnabled && this.singleListSelected && this.isPendingBuyerAction;
    }
    return this.showProcessingBanner;
  }

  get isPendingSellerAction(): boolean {
    if (this.auctionItemSell.offers) {
      const offerStatus = this.auctionItemSell.offers[0].status;
      return offerStatus === SellerOfferStatus.BUYER_OFFERED || offerStatus === SellerOfferStatus.BUYER_COUNTERED;
    }
    return false;
  }

  get isPendingBuyerAction(): boolean {
    if (this.auctionItemSell.offers) {
      const offerStatus = this.auctionItemSell.offers[0].status;
      return offerStatus === SellerOfferStatus.SELLER_OFFERED || offerStatus === SellerOfferStatus.SELLER_COUNTERED;
    }
    return false;
  }

  get isSellReportingFeatureEnabled() {
    return this.launchDarklyService.getFeatureFlag('sell-saleReportsEnabled', false);
  }

  analyticsInfo(pageDetails: string) {
    this._analyticsService.trackEvent('app-tooltip', pageDetails);
  }

  analyticsClickEvent(name: string, property: string) {
    this._analyticsService.trackEvent(name, property);
  }

  get isEditDisabled() {
    return this.showProcessingBanner || this.auctionItemSell.bidCount > 0;
  }

  isEditCutOffTime() {
    if (this.isEditDisabled === false) {
      this.inventoryService
        .getEditTimeCutoff(
          this.auctionItemSell.inventoryItemUuid,
          this.editPostingUtilsService.getSelectedDealershipUuid(this.auctionItemSell?.seller?.organizationEntityUuid)
        )
        .pipe(take(1))
        .subscribe((cutOffResponse: any) => {
          if (cutOffResponse.isWithinEditCutoffThreshold === true) {
            this.router.navigate(['/inventory/edit/' + this.auctionItemSell?.inventoryItemUuid]);
            this.updateBackToInventory();
          } else {
            this.errorModal.message = this.editCutoffErrorMessage;
            this.errorModal.btnCloseAlignCenter = true;
            this.errorModal.show();
            this.changeDetectorRef.markForCheck();
          }
        });
    }
  }

  get isNotDirty() {
    return this.auctionItemSell.isDirty !== true;
  }

  isTenantCanadian() {
    return this.launchDarklyService.getFeatureFlag('canadianTenantEnabled', false);
  }

  isVinDecodeRequired() {
    const datePosted = new Date(this.getAuctionItemSellProp('postedDate'));
    const currentDate = new Date();
    return this.dateUtilService.getDifferenceInDaysBetweenTwoDates(datePosted, currentDate) > 60;
  }

  onClickRepost(event: Event, vin: string) {
    event.preventDefault();
    if (this.isVinDecodeRequired()) {
      this.editPostingService
        .getVinDecodeDetails(vin, false)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          response => {
            this.router.navigate(['/inventory/repost/', this.auctionItemSell?.inventoryItemUuid]);
            this.updateBackToInventory();
          },
          error => {
            this.errorModal.message = this.getErrorMessage(error, vin);
            this.errorModal.btnCloseAlignCenter = true;
            this.errorModal.show();
            this.changeDetectorRef.markForCheck();
          }
        );
    } else {
      this.router.navigate(['/inventory/repost/', this.auctionItemSell?.inventoryItemUuid]);
      this.updateBackToInventory();
    }
  }

  showAvailableMultiActions() {
    this.auctionItemSell.offers.forEach(offer => {
      this.showViewOffers = true;
      offer.offerActions.forEach(offerAction => {
        this.sellerActionMapCounter.set(offerAction, this.sellerActionMapCounter.get(offerAction) + 1);
      });
    });
  }

  getErrorMessage(errorRes, vin: string) {
    let errorMessage = 'The VIN service is unavailable. Try again later.';
    if (!errorRes.error || !errorRes.error.errors) {
      return errorMessage;
    }
    switch (errorRes.error.errors[0].code) {
      case 'F-REMPLT-IIS-VINACTHLD':
        errorMessage = `<b>VIN ${vin}</b> is on hold or is in active status.`;
        break;
      case 'F-REMPLT-IIS-VINNF':
      case 'F-REMPLT-IIS-INVLDVIN':
        errorMessage = `<b>VIN ${vin}</b> is not found in our service.`;
        break;
      case 'F-REMPLT-IIS-ASTSVCUNAVL':
        errorMessage = 'The VIN service is unavailable. Try again later.';
        break;
    }
    return errorMessage;
  }

  get isOfferListSellerSelectAllEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('offerlist-seller-selectAllEnabled', true);
  }

  localizeDateAndTime(dateTime) {
    return this.dateUtilService.localizeDateAndTime(dateTime, true);
  }

  get isCustomerInfoEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-customerInfoEnabled', false);
  }

  get isReleaseProceedsEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-adminReleaseProceedsEnabled', true);
  }

  get inServiceVehiclesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }

  get isReservationsEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('global-reservationsEnabled', false);
  }
  get isInspectionSeriesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inspectionSeriesEnabled', false);
  }

  get yellowLightDisclosureCount() {
    return this.auctionItemSell.disclosures.yellowLights?.length;
  }

  get yellowLightDisclosureList() {
    return get(this.auctionItemSell, 'disclosures.yellowLights', []);
  }

  get limitedArbitration() {
    return this.auctionItemSell.disclosures.limitedArbitration;
  }

  get isSellVehicleCardDisclosuresEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('sell-vehicleCardDisclosuresEnabled', false);
  }

  get isInServiceVehiclesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }
}
